module.exports = __webpack_public_path__ + "img/shenfen@3x.818f47eb.svg";